type QueryParams = { [key: string]: string | string[] | undefined }

export const getQueryParam = (queryParams: QueryParams, key: string): string | undefined => {
  const param = queryParams[key]

  if (Array.isArray(param)) {
    return param[0]
  }

  return param
}
